import styled from 'styled-components';

export const HomeBodyContent = styled.div`
  overflow-y: auto;
  overscroll-behavior: contain;
  @media (max-width: ${({ theme }) => theme.breakpoint.sm}) {
    max-height: none;
  }
`;
